import { useCallback, useMemo } from 'react'
import { ButtonPrimary, ButtonRedSecondary } from '../../../../../../../../baseComponents/Button'
import { ModalButtons, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import CustomSelect from '../../../../../../../../forms/CustomSelect'
import LoadingSpinner from '../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'

interface ModalProductPackOrderProps extends ModalProductPackOrderLogicProps {
}

const ModalProductPackOrder: React.FC<ModalProductPackOrderProps> = ({ ...logic }) => {
    const {t} = useTwinTranslation()
    const { loading, onPreSubmit, endLoading, onSubmit, dictionaryParsed, deleteRow } = useModalProductPackOrder({ ...logic })
    return (
        <ModalSmallCentered opened={true} setOpened={() => { }} onClickOut={false} className='small_padding flex_height'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={logic?.inputTableURLs?.updateData} onSubmit={onSubmit} onError={endLoading} className='flex flex-auto flex-col justify-between'>
                <div>
                    <h2><TwinTrans transKey='mustSelectUnits'>Debes seleccionar las unidades</  TwinTrans></h2>
                    <h4><span className='text-green-21'>{logic.element.reference}</span> -  {logic.element.name}</h4>
                </div>
                {loading ? <LoadingSpinner /> : <CustomSelect required={true} label={t('units', 'Unidades')} items={dictionaryParsed} name='packQuantity' value={logic.element.packQuantity} />}
                {!loading ? 
                    <ModalButtons className='mt-20'>
                        <ButtonRedSecondary type='button' onClick={deleteRow}>{t('deleteRow', 'Eliminar fila')}</ButtonRedSecondary>
                        <ButtonPrimary>{t('accept', 'Aceptar')}</ButtonPrimary>
                    </ModalButtons>
                 : null}
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalProductPackOrderLogicProps {
    inputTableURLs: InputTableURLsTable
    element: TwinDictionary
    getData: () => void
}

const useModalProductPackOrder = ({ element, getData, inputTableURLs }: ModalProductPackOrderLogicProps) => {
    const { t } = useTwinTranslation()
    const { startLoading, endLoading, loading } = useIsLoading()
    const individualUnitsText = t('individualUnits', 'Unidades individuales')
    const packText = t('pack', 'Pack')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading()
        vals.id = element.id
        if (parseFloat(String(vals.packQuantity)) !==1){
            vals.quantity = 1
        }
        return true
    }, [startLoading, element])

    const onSubmit: OnSubmit = useCallback(() => {
        getData()
        endLoading()
    }, [endLoading, getData])


    const deleteRow = useCallback(async () => {
        if (inputTableURLs.delete) {
            const res = await twinFetchPostJSON(inputTableURLs.delete, { id: element.id })
            if (res) {
                getData()
            }
        }
    }, [inputTableURLs?.delete, element.id, getData])

    const dictionaryParsed = useMemo(() => {
        const myItems: TwinDictionary = {}
        if(element?.packQuantities){
            for (const myelement of element.packQuantities) {
                if (parseInt(String(myelement)) === 1) {
                    myItems[myelement] = { name: individualUnitsText }
                } else {
                    myItems[myelement] = { name: packText + ' ' + myelement }
                }
            }
        }
        return myItems
    }, [element.packQuantities, individualUnitsText, packText])
    return { loading, onPreSubmit, endLoading, onSubmit, dictionaryParsed, deleteRow }
}

export default ModalProductPackOrder